// import _ from 'lodash'
import Cookies from 'js-cookie'
// import Constants from '@/constants'

const KeySurveyStatus = 'CmsSurveyStatus'

const SET_OPT = { expires: 7 }

// token

export function getSurveyStatus () {
  return Cookies.get(KeySurveyStatus)
}

export function setSurveyStatus (status) {
  return Cookies.set(KeySurveyStatus, status, SET_OPT)
}

export function removeSurveyStatus () {
  return Cookies.remove(KeySurveyStatus)
}

export default {
  getSurveyStatus,
  setSurveyStatus,
  removeSurveyStatus
}



// WEBPACK FOOTER //
// ./src/utils/auth.js